G.GroupColliderLineLine = function(group1,group2,callback,context) {

	G.Image.call(this,0,0,null);

	this.group1 = group1;
	this.group2 = group2;
	this.callback = callback;
	this.context = context || null;

	this.collPoint = new Phaser.Point(0,0);

};

G.GroupColliderLineLine.prototype = Object.create(G.Image.prototype);

G.GroupColliderLineLine.prototype.update = function() {

	var len1 = this.group1.length;
	var len2 = this.group2.length;

	for (var i = 0; i < len1; i++) {
		var e1 = this.group1.children[i];
		for (var j = 0; j < len2; j++) {
			var e2 = this.group2.children[j];
			if (e1 === e2) continue;

			if (e1.collLine.intersects(e2.collLine, true, this.collPoint)) {
				this.callback.call(this.context,e1,e2,this.collPoint,this.group1,this.group2);
			} 

		}
	}

};


G.GroupColliderLineCircle = function(group1,group2,callback,context) {

	G.Image.call(this,0,0,null);

	this.group1 = group1;
	this.group2 = group2;
	this.callback = callback;
	this.context = context || null;

	this.collPoint = new Phaser.Point(0,0);

};

G.GroupColliderLineCircle.prototype = Object.create(G.Image.prototype);

G.GroupColliderLineCircle.prototype.update = function() {

	var len1 = this.group1.length;
	var len2 = this.group2.length;

	for (var i = this.group1.length; i--;) {
		var e1 = this.group1.children[i];
		for (var j = this.group2.length; j--;) {
			var e2 = this.group2.children[j];
			if (e1 === e2) continue;

			if (G.lineCircleColl(e1.collLine,e2.collCircle,this.collPoint)){
				this.callback.call(this.context,e1,e2,this.collPoint,this.group1,this.group2);
			} 

		}
	}

};